import { RecentVerificationDataPoint } from "./recentVerificationDataPoint.js";
import { SproutVerificationChecks } from "./sproutVerificationChecks.js";

export enum SproutVerificationInstanceMockPreset {
    SuccessfulOpen = "SuccessfulOpen",
    SuccessfulClosed = "SuccessfulClosed",
    Pending = "Pending",
    Failed = "Failed",
}

type PresetData = {
    openVerification: boolean;
    someUncertainty: boolean;
    valvesIntendedOpen: boolean[];
    valveTransitionDate: Date;
    lastDeviceContact: Date;
    reportedValvesOpen: boolean[];
    date: Date;
    dataMeasured: RecentVerificationDataPoint[];
    inProgress: boolean;
    pendingData: boolean;
    successful: boolean;
    verificationChecks: SproutVerificationChecks;
};

export function getMockPresets(): Record<SproutVerificationInstanceMockPreset, PresetData> {
    return {
        [SproutVerificationInstanceMockPreset.SuccessfulOpen]: {
            openVerification: true,
            someUncertainty: false,
            valvesIntendedOpen: [true, false],
            valveTransitionDate: new Date("2024-01-01"),
            lastDeviceContact: new Date("2024-01-01"),
            reportedValvesOpen: [true, false],
            date: new Date("2024-01-01"),
            dataMeasured: [],
            inProgress: false,
            pendingData: false,
            successful: true,
            verificationChecks: new SproutVerificationChecks(),
        },
        [SproutVerificationInstanceMockPreset.SuccessfulClosed]: {
            openVerification: false,
            someUncertainty: false,
            valvesIntendedOpen: [false, false],
            valveTransitionDate: new Date("2024-01-01"),
            lastDeviceContact: new Date("2024-01-01"),
            reportedValvesOpen: [false, false],
            date: new Date("2024-01-01"),
            dataMeasured: [],
            inProgress: false,
            pendingData: false,
            successful: true,
            verificationChecks: new SproutVerificationChecks(),
        },
        [SproutVerificationInstanceMockPreset.Pending]: {
            openVerification: true,
            someUncertainty: true,
            valvesIntendedOpen: [true, false],
            valveTransitionDate: new Date("2024-01-01"),
            lastDeviceContact: new Date("2024-01-01"),
            reportedValvesOpen: [false, false],
            date: new Date("2024-01-01"),
            dataMeasured: [],
            inProgress: true,
            pendingData: true,
            successful: false,
            verificationChecks: new SproutVerificationChecks(),
        },
        [SproutVerificationInstanceMockPreset.Failed]: {
            openVerification: true,
            someUncertainty: false,
            valvesIntendedOpen: [true, false],
            valveTransitionDate: new Date("2024-01-01"),
            lastDeviceContact: new Date("2024-01-01"),
            reportedValvesOpen: [false, false],
            date: new Date("2024-01-01"),
            dataMeasured: [],
            inProgress: false,
            pendingData: false,
            successful: false,
            verificationChecks: new SproutVerificationChecks(),
        },
    };
}
